// Autogenerated file
export const featureModuleTypesEnum = {
    PlanningCarSchedule: "PlanningCarSchedule",
    RefuelingPlanning: "RefuelingPlanning",
    AxisLoadMonitoring: "AxisLoadMonitoring",
    Scenarios: "Scenarios",
    CarSensorMonitoring: "CarSensorMonitoring",
    CounterpartiesSolvency: "CounterpartiesSolvency",
    PlanDistanceBetweenPoints: "PlanDistanceBetweenPoints",
    MultipleBidCargos: "MultipleBidCargos",
    BidPointPlanningLeaveDate: "BidPointPlanningLeaveDate",
    HereServices: "HereServices",
    PlanEmptyMileageBid: "PlanEmptyMileageBid",
    TripCoupling: "TripCoupling",
    DriverControlPoints: "DriverControlPoints",
    TachographEstimationDate: "TachographEstimationDate",
    CarIdlesAtBidPointNotification: "CarIdlesAtBidPointNotification",
    DraftWithoutConstraintOnTheSequenceOfPoints: "DraftWithoutConstraintOnTheSequenceOfPoints",
    BidAverageRateRestriction: "BidAverageRateRestriction",
    Factoring: "Factoring",
    Forwarding: "Forwarding",
    CalculationLogisticSalary: "CalculationLogisticSalary",
    TemperatureRegime: "TemperatureRegime",
    Payslips: "Payslips",
    ProfitabilityOfBid: "ProfitabilityOfBid",
    DocumentAssignment: "DocumentAssignment",
    DriverEducationResources: "DriverEducationResources",
    BidSalesManager: "BidSalesManager",
    Exploitation: "Exploitation",
    DriverMileageCalculation: "DriverMileageCalculation",
    BidAcceptLatenessNotification: "BidAcceptLatenessNotification",
    Waybills: "Waybills",
    TripScenarios: "TripScenarios",
    Marginality: "Marginality",
    BidPointsAdjustment: "BidPointsAdjustment",
    Messenger: "Messenger",
    DriverWorkAndRest: "DriverWorkAndRest",
    PairedCrew: "PairedCrew",
    TrackerLogsFiltering: "TrackerLogsFiltering",
    AccessToRelays: "AccessToRelays",
    RatingOfDriversAndLogists: "RatingOfDriversAndLogists",
    UnstableZones: "UnstableZones",
    AccountsReceivable: "AccountsReceivable",
    ReportSnapshot: "ReportSnapshot",
    KonturIntegration: "KonturIntegration",
    DriverSalary: "DriverSalary",
    CrStart: "CrStart",
    RouteControlPoints: "RouteControlPoints",
    PriceForInvoice: "PriceForInvoice",
};
export const featureModuleTypes = [
    { label: "Планирование", value: "PlanningCarSchedule" },
    { label: "Планирование заправок", value: "RefuelingPlanning" },
    { label: "Нагрузка на ось", value: "AxisLoadMonitoring" },
    { label: "Сценарии", value: "Scenarios" },
    { label: "Мониторинг датчиков машины", value: "CarSensorMonitoring" },
    { label: "Платежеспособность контрагентов", value: "CounterpartiesSolvency" },
    { label: "Плановое расстояние между точками", value: "PlanDistanceBetweenPoints" },
    { label: "Множественность грузов в заявке", value: "MultipleBidCargos" },
    { label: "Управление плановой датой выезда", value: "BidPointPlanningLeaveDate" },
    { label: "Сервисы Here", value: "HereServices" },
    { label: "Порожний пробег в заявке", value: "PlanEmptyMileageBid" },
    { label: "Смена", value: "TripCoupling" },
    { label: "Задание водителя на смену 2.0", value: "DriverControlPoints" },
    { label: "Расчет времени прибытия по тахографам", value: "TachographEstimationDate" },
    { label: "Уведомление по простою на маршрутной точке", value: "CarIdlesAtBidPointNotification" },
    { label: "Черновик без ограничения по маршрутным точкам", value: "DraftWithoutConstraintOnTheSequenceOfPoints" },
    { label: "Ограничение запуска заявки по её нахождению в рынке", value: "BidAverageRateRestriction" },
    { label: "Факторинг", value: "Factoring" },
    { label: "Загрузки", value: "Forwarding" },
    { label: "Расчет ЗП логистов", value: "CalculationLogisticSalary" },
    { label: "Температурный режим", value: "TemperatureRegime" },
    { label: "Расчётные листы", value: "Payslips" },
    { label: "Рентабельность заявки", value: "ProfitabilityOfBid" },
    { label: "Сдача документов", value: "DocumentAssignment" },
    { label: "Обучающие ресурсы водителей", value: "DriverEducationResources" },
    { label: "Роль в заявке Менеджер по продажам", value: "BidSalesManager" },
    { label: "Cargorun Эксплуатация", value: "Exploitation" },
    { label: "Расчет пробега водителя 1.0", value: "DriverMileageCalculation" },
    { label: "Уведомление 'Водитель не принял заявку в течение 1 часа'", value: "BidAcceptLatenessNotification" },
    { label: "Электронные перевозочные документы", value: "Waybills" },
    { label: "Опрос в рейсе", value: "TripScenarios" },
    { label: "Маржинальность", value: "Marginality" },
    { label: "Автоматическое определение точек заявки", value: "BidPointsAdjustment" },
    { label: "Отправка сообщений в мессенджер", value: "Messenger" },
    { label: "РТО Водители", value: "DriverWorkAndRest" },
    { label: "Парные экипажи", value: "PairedCrew" },
    { label: "Фильтрация трекер логов", value: "TrackerLogsFiltering" },
    { label: "Доступ к ретранслятору", value: "AccessToRelays" },
    { label: "Рейтинг водителей и логистов", value: "RatingOfDriversAndLogists" },
    { label: "Зоны нестабильных координат", value: "UnstableZones" },
    { label: "Дебиторская задолженность", value: "AccountsReceivable" },
    { label: "Фиксация данных в отчете", value: "ReportSnapshot" },
    { label: "Интеграция с Контур", value: "KonturIntegration" },
    { label: "Расчет ЗП водителей", value: "DriverSalary" },
    { label: "CR Start", value: "CrStart" },
    { label: "Контроль планового маршрута", value: "RouteControlPoints" },
    { label: "Стоимость для счёта", value: "PriceForInvoice" },
];
